import { writable } from 'svelte/store'

/** Singleton open/close state for the keyboard shortcut help modal. App.svelte
 *  flips it on the global "?" key; HelpModal subscribes and shows/hides the
 *  underlying <dialog>. Externalised so any future caller (e.g. a "help"
 *  button on the toolbar) can open the modal without grabbing a component
 *  reference. */
export const helpOpen = writable(false)

export function openHelp(): void {
  helpOpen.set(true)
}

export function closeHelp(): void {
  helpOpen.set(false)
}
